import { Response } from './Response';

export class OrderDataV2Response extends Response {
  get orderId() {
    return this.data.orderId;
  }

  get creationDate() {
    return this.data.creationDate;
  }

  get suborders(): Array<Suborder> {
    return this.data.suborders;
  }
}

export type Suborder = {
  id: string;
  articlesCount: number;
};
